// extracted by mini-css-extract-plugin
export default {"responsiveBackground":"axpN2B"};